import React from "react";
import MonthYearPicker from "../component-tools/MonthYearPicker";

export interface LegalName {
  lnFirstName: string;
  lnLastName: string;
  lnMiddleName: string;
  lnFromDate: Date;
  lnToDate: Date;
  confidential: boolean;
}

interface LegalNamesProps {
  legalName: LegalName;
  validationErrors: { [key: string]: string };
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index: number,
  ) => void;
  onDelete: () => void;
  index: number;
  other?: boolean;
}

const LegalNamesForm: React.FC<LegalNamesProps> = ({
  legalName,
  validationErrors,
  onInputChange,
  onDelete,
  index,
  other,
}) => {
  return (
    <div className="data-container">
      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">
          {other ? "First Name" : "First Legal Name:"}
        </label>
        <div className="field-input">
          <input
            className={`form-control ${
              validationErrors[`lnFirstName-${index}`] ? "is-invalid" : ""
            }`}
            type="text"
            value={legalName.lnFirstName || ""}
            onChange={(e) => onInputChange(e, "lnFirstName", index)}
          />
          {validationErrors[`lnFirstName-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`lnFirstName-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">
          {other ? "Middle Name" : "Middle Legal Name:"}
        </label>
        <div className="field-input">
          <input
            className="form-control"
            type="text"
            value={legalName.lnMiddleName || ""}
            onChange={(e) => onInputChange(e, "lnMiddleName", index)}
          />
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">
          {other ? "Last Name" : "Last Legal Name:"}
        </label>
        <div className="field-input">
          <input
            className={`form-control ${
              validationErrors[`lnLastName-${index}`] ? "is-invalid" : ""
            }`}
            type="text"
            value={legalName.lnLastName || ""}
            onChange={(e) => onInputChange(e, "lnLastName", index)}
          />
          {validationErrors[`lnLastName-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`lnLastName-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">From:</label>
        <div className="field-input">
          <MonthYearPicker
            value={legalName.lnFromDate}
            onChange={(newDate) =>
              onInputChange(
                { target: { value: newDate } } as any,
                "lnFromDate",
                index,
              )
            }
          />
          {validationErrors[`lnFromDate-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`lnFromDate-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">To:</label>
        <div className="field-input">
          <MonthYearPicker
            value={legalName.lnToDate}
            onChange={(newDate) =>
              onInputChange(
                { target: { value: newDate } } as any,
                "lnToDate",
                index,
              )
            }
          />
          {validationErrors[`lnToDate-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`lnToDate-${index}`]}
            </div>
          )}
        </div>
      </div>

      {other && (
        <div className="field-long" style={{ flex: "0 0 50%" }}>
          <div className="field-input" style={{ flex: "0 0 5%" }}>
            <input
              className={`form-check-input`}
              type="checkbox"
              checked={legalName.confidential}
              onChange={(e) => onInputChange(e, "confidential", index)}
            />
          </div>

          <label className="field-label" style={{ textWrap: "wrap" }}>
            Should this name remain confidential?
          </label>
        </div>
      )}

      <div style={{ flex: "0 0 100%" }}>
        <button className="oxbtn btn-red" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default LegalNamesForm;
